export enum CancelPendingPaymentsAnalyticsMessages {
  capability = 'payments',
  cancelPaymentEvent = 'cancel payment',
}
